// import React, { useState, useEffect } from "react";

// import axios from "axios";
// import { User, Camera } from "lucide-react";

// const AdminProfile = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     currentPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//     image: null,
//     imagePreview: "",
//   });
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [message, setMessage] = useState({ text: "", type: "" });

//   // Get token from localStorage (where you store it after login)
//   const getAuthToken = () => {
//     // Check where you store your token after admin login
//     return localStorage.getItem("adminToken") || 
//            localStorage.getItem("token") || 
//            sessionStorage.getItem("adminToken") || 
//            "";
//   };

//   useEffect(() => {
//     fetchAdminProfile();
//   }, []);

//   const fetchAdminProfile = async () => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
      
//       if (!token) {
//         setMessage({ 
//           text: "Please login first", 
//           type: "error" 
//         });
//         setLoading(false);
//         return;
//       }

//       const response = await axios.get(
//         // "https://grocerrybackend.vercel.app/api/admin/profile", // ✅ CHANGED from /register to /profile
//         "https://grocerrybackend.vercel.app/api/admin/profile",
//         {
//           headers: {
//             Authorization: `Bearer ${token}` // ✅ ADDED authentication header
//           }
//         }
//       );
      
//       const { name, email, image } = response.data.admin; // ✅ Access response.data.admin
//       setFormData(prev => ({
//         ...prev,
//         name,
//         email,
//         imagePreview: image || ""
//       }));
//     } catch (error) {
//       console.error("Error fetching admin profile:", error);
//       setMessage({ 
//         text: error.response?.data?.message || "Failed to load profile", 
//         type: "error" 
//       });
      
//       // Handle unauthorized access
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         // Token expiblue or invalid - blueirect to login
//         localStorage.removeItem("adminToken");
//         // You might want to blueirect to login page here
//         // window.location.href = "/admin/login";
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 5 * 1024 * 1024) { // ✅ Updated to 5MB for Cloudinary
//         setMessage({ 
//           text: "Image size should be less than 5MB", 
//           type: "error" 
//         });
//         return;
//       }
      
//       // Validate file type
//       const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
//       if (!validTypes.includes(file.type)) {
//         setMessage({ 
//           text: "Only JPEG, PNG, JPG, and WebP images are allowed", 
//           type: "error" 
//         });
//         return;
//       }
      
//       setFormData(prev => ({
//         ...prev,
//         image: file,
//         imagePreview: URL.createObjectURL(file)
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     setMessage({ text: "", type: "" });

//     // Validate passwords
//     if (formData.newPassword && formData.newPassword !== formData.confirmPassword) {
//       setMessage({ text: "New passwords don't match", type: "error" });
//       setSaving(false);
//       return;
//     }

//     // If new password is enteblue, current password is requiblue
//     if (formData.newPassword && !formData.currentPassword) {
//       setMessage({ 
//         text: "Please enter current password to change password", 
//         type: "error" 
//       });
//       setSaving(false);
//       return;
//     }

//     // Validate password length
//     if (formData.newPassword && formData.newPassword.length < 6) {
//       setMessage({ 
//         text: "Password must be at least 6 characters long", 
//         type: "error" 
//       });
//       setSaving(false);
//       return;
//     }

//     const dataToSend = new FormData();
//     dataToSend.append("name", formData.name);
//     dataToSend.append("email", formData.email);
    
//     if (formData.currentPassword) {
//       dataToSend.append("currentPassword", formData.currentPassword);
//     }
//     if (formData.newPassword) {
//       dataToSend.append("newPassword", formData.newPassword);
//     }
//     if (formData.image) {
//       dataToSend.append("image", formData.image);
//     }

//     try {
//       const token = getAuthToken();
      
//       if (!token) {
//         setMessage({ 
//           text: "Please login first", 
//           type: "error" 
//         });
//         setSaving(false);
//         return;
//       }

//       const response = await axios.put(
//         "https://grocerrybackend.vercel.app//api/admin/profile", // ✅ CHANGED from /register to /profile
//         dataToSend,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Bearer ${token}` // ✅ ADDED authentication header
//           }
//         }
//       );

//       setMessage({ 
//         text: response.data.message || "Profile updated successfully!", 
//         type: "success" 
//       });

//       // Update form data with response data
//       const { name, email, image } = response.data.admin;
//       setFormData(prev => ({
//         ...prev,
//         name,
//         email,
//         imagePreview: image || prev.imagePreview,
//         currentPassword: "",
//         newPassword: "",
//         confirmPassword: "",
//         image: null
//       }));
      
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       setMessage({ 
//         text: error.response?.data?.message || "Failed to update profile", 
//         type: "error" 
//       });
      
//       // Handle unauthorized access
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         localStorage.removeItem("adminToken");
//         // blueirect to login page
//         // window.location.href = "/admin/login";
//       }
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-4">
//       <div className="mb-6">
//         <h1 className="text-xl font-bold text-gray-800">Admin Profile</h1>
//       </div>

//       <div className="bg-white rounded-lg shadow-sm border border-gray-200">
//         <div className="px-4 py-6 border-b border-gray-200">
//           <div className="flex items-center space-x-4">
//             <div className="relative">
//               <div className="h-16 w-16 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 border-2 border-white shadow overflow-hidden">
//                 {formData.imagePreview ? (
//                   <img 
//                     src={formData.imagePreview} 
//                     alt="Profile" 
//                     className="h-full w-full object-cover"
//                   />
//                 ) : (
//                   <div className="h-full w-full flex items-center justify-center">
//                     <User size={28} className="text-blue-500" />
//                   </div>
//                 )}
//               </div>
//               <label className="absolute bottom-0 right-0 bg-white rounded-full p-1 shadow border border-gray-200 cursor-pointer hover:bg-gray-50">
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageChange}
//                   className="hidden"
//                 />
//                 <Camera size={14} className="text-gray-600" />
//               </label>
//             </div>
//             <div>
//               <h2 className="font-semibold text-gray-800">{formData.name}</h2>
//               <p className="text-sm text-gray-600">{formData.email}</p>
//               <p className="text-xs text-gray-500 mt-1">
//                 Max file size: 5MB • Formats: JPEG, PNG, WebP
//               </p>
//             </div>
//           </div>
//         </div>

//         <form onSubmit={handleSubmit} className="p-4">
//           {message.text && (
//             <div className={`mb-4 p-3 rounded-lg ${message.type === 'success' ? 'bg-green-50 text-green-800 border border-green-200' : 'bg-blue-50 text-blue-800 border border-blue-200'}`}>
//               {message.text}
//             </div>
//           )}

//           <div className="space-y-4 mb-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Full Name *
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                 requiblue
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Email Address *
//               </label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                 requiblue
//               />
//             </div>
//           </div>

//           <div className="border-t border-gray-200 pt-6 mb-6">
//             <h3 className="font-semibold text-gray-800 mb-4">Change Password</h3>
//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Current Password
//                 </label>
//                 <input
//                   type="password"
//                   name="currentPassword"
//                   value={formData.currentPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Enter current password"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   New Password
//                 </label>
//                 <input
//                   type="password"
//                   name="newPassword"
//                   value={formData.newPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="At least 6 characters"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Confirm New Password
//                 </label>
//                 <input
//                   type="password"
//                   name="confirmPassword"
//                   value={formData.confirmPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Confirm new password"
//                 />
//               </div>
//             </div>
//             <p className="text-xs text-gray-500 mt-3">
//               * Leave password fields empty if you don't want to change your password
//             </p>
//           </div>

//           <div className="flex flex-col-reverse gap-3 pt-6 border-t border-gray-200">
//             <button
//               type="submit"
//               disabled={saving}
//               className="w-full py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm"
//             >
//               {saving ? (
//                 <span className="flex items-center justify-center">
//                   <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Saving...
//                 </span>
//               ) : 'Update Profile'}
//             </button>
//             <button
//               type="button"
//               onClick={() => {
//                 setFormData(prev => ({
//                   ...prev,
//                   currentPassword: "",
//                   newPassword: "",
//                   confirmPassword: ""
//                 }));
//                 setMessage({ text: "", type: "" });
//               }}
//               className="w-full py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors text-sm"
//               disabled={saving}
//             >
//               Clear Passwords
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AdminProfile;












// import React, { useState } from "react";
// import axios from "axios";

// const AdminProfile = () => {
//   const [formData, setFormData] = useState({
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [saving, setSaving] = useState(false);
//   const [message, setMessage] = useState({ text: "", type: "" });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     setMessage({ text: "", type: "" });

//     // Simple validation
//     if (!formData.oldPassword || !formData.newPassword) {
//       setMessage({ 
//         text: "Please enter both old and new password", 
//         type: "error" 
//       });
//       setSaving(false);
//       return;
//     }

//     if (formData.newPassword !== formData.confirmPassword) {
//       setMessage({ text: "New passwords don't match", type: "error" });
//       setSaving(false);
//       return;
//     }

//     // Password change functionality
//     try {
//       const userId = localStorage.getItem("userId") || 
//                     localStorage.getItem("adminId") || "";
      
//       const token = localStorage.getItem("adminToken") || 
//                     localStorage.getItem("token") || "";
      
//       if (!userId) {
//         setMessage({ 
//           text: "User ID not found. Please login again.", 
//           type: "error" 
//         });
//         setSaving(false);
//         return;
//       }

//       if (!token) {
//         setMessage({ 
//           text: "Please login first", 
//           type: "error" 
//         });
//         setSaving(false);
//         return;
//       }

//       // Password change API call
//       await axios.post(
//         "https://grocerrybackend.vercel.app/api/user/change-password", 
//         {
//           userId,
//           oldPassword: formData.oldPassword,
//           newPassword: formData.newPassword,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         }
//       );

//       setMessage({ 
//         text: "✅ Password updated successfully", 
//         type: "success" 
//       });

//       // Clear password fields after successful change
//       setFormData({
//         oldPassword: "",
//         newPassword: "",
//         confirmPassword: ""
//       });

//     } catch (err) {
//       console.error("Password change error:", err);
//       setMessage({ 
//         text: err.response?.data?.message || "Password update failed", 
//         type: "error" 
//       });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <>
//    {/* <div className="p-4"> */}
//       <div className="mb-6">
//         <h1 className="text-xl font-bold text-gray-800">Change Password</h1>
//       </div>

//       <div className="bg-white rounded-lg shadow-sm border border-gray-200">
//         <div className="p-6">
//           {message.text && (
//             <div className={`mb-4 p-3 rounded-lg ${
//               message.type === 'success' 
//                 ? 'bg-green-50 text-green-800 border border-green-200' 
//                 : 'bg-blue-50 text-blue-800 border border-blue-200'
//             }`}>
//               {message.text}
//             </div>
//           )}

//           <form onSubmit={handlePasswordSubmit}>
//             <div className="space-y-4 mb-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Old Password *
//                 </label>
//                 <input
//                   type="password"
//                   name="oldPassword"
//                   value={formData.oldPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Enter old password"
//                   requiblue
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   New Password *
//                 </label>
//                 <input
//                   type="password"
//                   name="newPassword"
//                   value={formData.newPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Enter new password"
//                   requiblue
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Confirm New Password *
//                 </label>
//                 <input
//                   type="password"
//                   name="confirmPassword"
//                   value={formData.confirmPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Confirm new password"
//                   requiblue
//                 />
//               </div>
//             </div>

//             <div className="flex gap-3 pt-6 border-t border-gray-200">
//               <button
//                 type="submit"
//                 disabled={saving}
//                 className="w-full py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm"
//               >
//                 {saving ? 'Changing Password...' : 'Change Password'}
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setFormData({
//                     oldPassword: "",
//                     newPassword: "",
//                     confirmPassword: ""
//                   });
//                   setMessage({ text: "", type: "" });
//                 }}
//                 className="w-full py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors text-sm"
//                 disabled={saving}
//               >
//                 Clear
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     {/*  </div> */}
//     </>
//   );
// };

// export default AdminProfile;





// import React, { useState } from "react";
// import axios from "axios";

// const AdminProfile = () => {
//   const [formData, setFormData] = useState({
//     oldPassword: "",
//     newPassword: ""
//   });
//   const [saving, setSaving] = useState(false);
//   const [message, setMessage] = useState({ text: "", type: "" });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     setMessage({ text: "", type: "" });

//     // Simple validation
//     if (!formData.oldPassword || !formData.newPassword) {
//       setMessage({ 
//         text: "Please enter both old and new password", 
//         type: "error" 
//       });
//       setSaving(false);
//       return;
//     }

//     // Password change functionality
//     try {
//       const userId = localStorage.getItem("userId");

//       await axios.post(
//         "https://grocerrybackend.vercel.app/api/user/change-password", 
//         {
//           userId,
//           oldPassword: formData.oldPassword,
//           newPassword: formData.newPassword,
//         }
//       );

//       setMessage({ 
//         text: "✅ Password updated successfully", 
//         type: "success" 
//       });

//       // Clear password fields after successful change
//       setFormData({
//         oldPassword: "",
//         newPassword: ""
//       });

//     } catch (err) {
//       console.error("Password change error:", err);
//       const errorMessage = err.response?.data?.message || 
//                           "Password update failed";
      
//       setMessage({ 
//         text: errorMessage, 
//         type: "error" 
//       });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="p-4">
//       <div className="mb-6">
//         <h1 className="text-xl font-bold text-gray-800">Change Password</h1>
//       </div>

//       <div className="bg-white rounded-lg shadow-sm border border-gray-200">
//         <div className="p-6">
//           {message.text && (
//             <div className={`mb-4 p-3 rounded-lg ${
//               message.type === 'success' 
//                 ? 'bg-green-50 text-green-800 border border-green-200' 
//                 : 'bg-blue-50 text-blue-800 border border-blue-200'
//             }`}>
//               {message.text}
//             </div>
//           )}

//           <form onSubmit={handlePasswordSubmit}>
//             <div className="space-y-4 mb-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Old Password *
//                 </label>
//                 <input
//                   type="password"
//                   name="oldPassword"
//                   value={formData.oldPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Enter old password"
//                   requiblue
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   New Password *
//                 </label>
//                 <input
//                   type="password"
//                   name="newPassword"
//                   value={formData.newPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Enter new password"
//                   requiblue
//                 />
//               </div>
//             </div>

//             <div className="flex gap-3 pt-6 border-t border-gray-200">
//               <button
//                 type="submit"
//                 disabled={saving}
//                 className="w-full py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm"
//               >
//                 {saving ? 'Changing Password...' : 'Change Password'}
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setFormData({
//                     oldPassword: "",
//                     newPassword: ""
//                   });
//                   setMessage({ text: "", type: "" });
//                 }}
//                 className="w-full py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors text-sm"
//                 disabled={saving}
//               >
//                 Clear
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminProfile;








// import React, { useState } from "react";
// import axios from "axios";

// // ✅ LOCAL BACKEND BASE URL
// const API_BASE = "https://grocerrybackend.vercel.app";

// export default function AdminProfile() {
//   const [oldPassword, setOldPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [msg, setMsg] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMsg("");

//     if (!oldPassword || !newPassword) {
//       setMsg("❌ Both fields are requiblue");
//       return;
//     }

//     try {
//       setLoading(true);

//       await axios.put(
//         `${API_BASE}/api/admin/update-password`,
//         {
//           oldPassword,
//           newPassword,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setMsg("✅ Password updated successfully");
//       setOldPassword("");
//       setNewPassword("");

//       // 🔒 Auto logout after password change
//       setTimeout(() => {
//         localStorage.clear();
//         window.location.href = "/login";
//       }, 1500);
//     } catch (err) {
//       setMsg(err.response?.data?.message || "❌ Update failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <h2 style={styles.title}>Admin Profile</h2>
//         <p style={styles.subtitle}>Change Password</p>

//         <form onSubmit={handleSubmit}>
//           <input
//             type="password"
//             placeholder="Old Password"
//             value={oldPassword}
//             onChange={(e) => setOldPassword(e.target.value)}
//             style={styles.input}
//           />

//           <input
//             type="password"
//             placeholder="New Password"
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//             style={styles.input}
//           />

//           <button style={styles.btn} disabled={loading}>
//             {loading ? "Updating..." : "Update Password"}
//           </button>
//         </form>

//         {msg && <p style={styles.msg}>{msg}</p>}
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "#f6f8fa",
//   },
//   card: {
//     background: "#fff",
//     padding: 30,
//     borderRadius: 12,
//     width: 360,
//     boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//   },
//   title: {
//     marginBottom: 4,
//     fontSize: 22,
//     fontWeight: 800,
//   },
//   subtitle: {
//     marginBottom: 20,
//     color: "#666",
//   },
//   input: {
//     width: "100%",
//     padding: 12,
//     marginBottom: 14,
//     borderRadius: 8,
//     border: "1px solid #ddd",
//     fontSize: 14,
//   },
//   btn: {
//     width: "100%",
//     padding: 12,
//     background: "#dc3545",
//     color: "#fff",
//     border: "none",
//     borderRadius: 8,
//     fontWeight: 700,
//     cursor: "pointer",
//   },
//   msg: {
//     marginTop: 14,
//     fontWeight: 600,
//     textAlign: "center",
//   },
// };



// import React, { useState } from "react";
// import axios from "axios";

// // ✅ LOCAL BACKEND BASE URL
// const API_BASE = "https://grocerrybackend.vercel.app";

// const AdminProfile = () => {
//   const [formData, setFormData] = useState({
//     oldPassword: "",
//     newPassword: ""
//   });
//   const [saving, setSaving] = useState(false);
//   const [message, setMessage] = useState({ text: "", type: "" });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     setMessage({ text: "", type: "" });

//     // Simple validation
//     if (!formData.oldPassword || !formData.newPassword) {
//       setMessage({ 
//         text: "Please enter both old and new password", 
//         type: "error" 
//       });
//       setSaving(false);
//       return;
//     }

//     try {
//       await axios.put(
//         `${API_BASE}/api/admin/update-password`,
//         {
//           oldPassword: formData.oldPassword,
//           newPassword: formData.newPassword,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setMessage({ 
//         text: "✅ Password updated successfully", 
//         type: "success" 
//       });

//       // Clear password fields after successful change
//       setFormData({
//         oldPassword: "",
//         newPassword: ""
//       });

//       // 🔒 Auto logout after password change
//       setTimeout(() => {
//         localStorage.clear();
//         window.location.href = "/login";
//       }, 1500);

//     } catch (err) {
//       console.error("Password change error:", err);
//       const errorMessage = err.response?.data?.message || 
//                           "Password update failed";
      
//       setMessage({ 
//         text: errorMessage, 
//         type: "error" 
//       });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="p-4">
//       <div className="mb-6">
//         <h1 className="text-xl font-bold text-gray-800">Admin Profile</h1>
//         <p className="text-sm text-gray-600 mt-1">Change Password</p>
//       </div>

//       <div className="bg-white rounded-lg shadow-sm border border-gray-200">
//         <div className="p-6">
//           {message.text && (
//             <div className={`mb-4 p-3 rounded-lg ${
//               message.type === 'success' 
//                 ? 'bg-green-50 text-green-800 border border-green-200' 
//                 : 'bg-blue-50 text-blue-800 border border-blue-200'
//             }`}>
//               {message.text}
//             </div>
//           )}

//           <form onSubmit={handlePasswordSubmit}>
//             <div className="space-y-4 mb-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Old Password *
//                 </label>
//                 <input
//                   type="password"
//                   name="oldPassword"
//                   value={formData.oldPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Enter old password"
//                   requiblue
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   New Password *
//                 </label>
//                 <input
//                   type="password"
//                   name="newPassword"
//                   value={formData.newPassword}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm"
//                   placeholder="Enter new password"
//                   requiblue
//                 />
//               </div>
//             </div>

//             <div className="flex gap-3 pt-6 border-t border-gray-200">
//               <button
//                 type="submit"
//                 disabled={saving}
//                 className="w-full py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm"
//               >
//                 {saving ? 'Changing Password...' : 'Change Password'}
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setFormData({
//                     oldPassword: "",
//                     newPassword: ""
//                   });
//                   setMessage({ text: "", type: "" });
//                 }}
//                 className="w-full py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors text-sm"
//                 disabled={saving}
//               >
//                 Clear
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };
import React, { useState } from "react";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react"; // Using lucide-react icons

// ✅ LOCAL BACKEND BASE URL
const API_BASE = "https://grocerrybackend.vercel.app";

const AdminProfile = () => {
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: ""
  });
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage({ text: "", type: "" });

    // Simple validation
    if (!formData.oldPassword || !formData.newPassword) {
      setMessage({ 
        text: "Please enter both old and new password", 
        type: "error" 
      });
      setSaving(false);
      return;
    }

    try {
      await axios.put(
        `${API_BASE}/api/admin/update-password`,
        {
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setMessage({ 
        text: "✅ Password updated successfully", 
        type: "success" 
      });

      // Clear password fields after successful change
      setFormData({
        oldPassword: "",
        newPassword: ""
      });

      // Hide passwords after success
      setShowPassword({
        oldPassword: false,
        newPassword: false
      });

      // 🔒 Auto logout after password change
      setTimeout(() => {
        localStorage.clear();
        window.location.href = "/login";
      }, 500);

    } catch (err) {
      console.error("Password change error:", err);
      const errorMessage = err.response?.data?.message || 
                          "Password update failed";
      
      setMessage({ 
        text: errorMessage, 
        type: "error" 
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-gray-800">Admin Profile</h1>
        <p className="text-sm text-gray-600 mt-1">Change Password</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-6">
          {message.text && (
            <div className={`mb-4 p-3 rounded-lg ${
              message.type === 'success' 
                ? 'bg-green-50 text-green-800 border border-green-200' 
                : 'bg-blue-50 text-blue-800 border border-blue-200'
            }`}>
              {message.text}
            </div>
          )}

          <form onSubmit={handlePasswordSubmit}>
            <div className="space-y-4 mb-6">
              {/* Old Password Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Old Password *
                </label>
                <div className="relative">
                  <input
                    type={showPassword.oldPassword ? "text" : "password"}
                    name="oldPassword"
                    value={formData.oldPassword}
                    onChange={handleChange}
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm pr-10"
                    placeholder="Enter old password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility("oldPassword")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                    aria-label={showPassword.oldPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword.oldPassword ? (
                      <EyeOff className="h-4 w-4" />
                    ) : (
                      <Eye className="h-4 w-4" />
                    )}
                  </button>
                </div>
              </div>

              {/* New Password Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  New Password *
                </label>
                <div className="relative">
                  <input
                    type={showPassword.newPassword ? "text" : "password"}
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-sm pr-10"
                    placeholder="Enter new password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility("newPassword")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                    aria-label={showPassword.newPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword.newPassword ? (
                      <EyeOff className="h-4 w-4" />
                    ) : (
                      <Eye className="h-4 w-4" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="flex gap-3 pt-6 border-t border-gray-200">
              <button
                type="submit"
                disabled={saving}
                className="w-full py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm"
              >
                {saving ? 'Changing Password...' : 'Change Password'}
              </button>
              <button
                type="button"
                onClick={() => {
                  setFormData({
                    oldPassword: "",
                    newPassword: ""
                  });
                  setShowPassword({
                    oldPassword: false,
                    newPassword: false
                  });
                  setMessage({ text: "", type: "" });
                }}
                className="w-full py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors text-sm"
                disabled={saving}
              >
                Clear
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
